import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { PracticeBatchInfo, PricingManagerClient } from 'src/app/shared/services/ppv.api'
import { VetcorPricingRowService } from '../vetcor-pricing-row.service'
import { Observable } from 'rxjs'
import { PricingRowVM } from '../vetcor-pricing-row.model'

@Component({
   selector: 'vc-reject-price-modal',
   standalone: false,
   templateUrl: './reject-price-modal.component.html',
   styleUrl: './reject-price-modal.component.scss',
})
export class RejectPriceModalComponent implements OnInit {
   @Input() rejectProduct: any

   @Output() onRowSave = new EventEmitter<PracticeBatchInfo>()

   rejectComment: string = ''
   rejectPriceDialogVisible: boolean = false
   rowData: PricingRowVM

   constructor(private toastr: ToastrService, private pricingManagerClient: PricingManagerClient, private pricingService: VetcorPricingRowService) {}

   ngOnInit(): void {
      const val = this.pricingService.selectedPrice()
      if (val) {
         this.rowData = val
      }
   }

   onPriceReject(product: any): void {
      event.stopPropagation()
      if (!this.rowData?.pricingChangeRequestId) {
         this.doPriceReject(product)
         return
      }
      this.rejectProduct = product
      this.rejectComment = ''
      this.rejectPriceDialogVisible = true
   }

   onConfirmReject() {
      this.rejectPriceDialogVisible = false
      this.rejectProduct.finalComment = this.rejectComment
      this.doPriceReject(this.rejectProduct)
   }

   doPriceReject(product: any): void {
      var toSave = {
         ...product,
         opsPrice: product.newPrice,
      }

      var apicall: Observable<any> = !this.rowData?.pricingChangeRequestId
         ? this.pricingManagerClient.rejectPricingUpdateRequest(toSave)
         : this.pricingManagerClient.rejectPricingChangeRequest({
              id: toSave.pricingChangeRequestId,
              finalComment: toSave.finalComment,
           } as any)

      apicall.subscribe({
         next: (data) => {
            product.captainApproved = 2

            product.isSaving = false
            this.onRowSave.emit(data)
         },
         error: (error) => {
            this.toastr.error('ERROR in communication with server. If the problem persist please contact support!')
         },
      })
   }
}
